export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    const cookieConsent = document.querySelector('.cookie-consent')
    const cookieConsentBtn = document.querySelector('.js-cookie-consent')
    if (!cookieConsent) return

    const hasAccepted = window.localStorage.getItem('cookie-consent-accepted')
    if (hasAccepted) {
      cookieConsent.style.display = 'none'
    } else {
      cookieConsent.style.display = 'block'
      cookieConsent.style.opacity = 0
      setTimeout(() => {
        cookieConsent.style.transition = 'opacity 1s ease'
        cookieConsent.style.opacity = 1
      }, 1000)
    }

    const fadeOut = () => {
      cookieConsent.style.opacity = 0
      setTimeout(() => {
        cookieConsent.style.display = 'none'
      }, 1000)
    }
    cookieConsentBtn.addEventListener('click', () => {
      fadeOut()
      localStorage.setItem('cookie-consent-accepted', 'true')
      return false
    })
  })
})()
